import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Students from "./pages/Students";
import QuizEditor from "./pages/QuizEditor";
import QuizList from "./pages/QuizList";
import Scanner from "./pages/Scanner";
import Results from "./pages/Results";
import Contact from "./pages/Contact";
import Abonnement from "./pages/Abonnement";
import Admin from "./pages/Admin";
import ResetPassword from "./pages/ResetPassword";
import ClassTracking from "./pages/ClassTracking";
import ClassDashboard from "./pages/ClassDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import TagsManager from "./pages/TagsManager";
import Layout from "./components/Layout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/students" element={<ProtectedRoute><Students /></ProtectedRoute>} />
      <Route path="/quizzes" element={<ProtectedRoute><QuizList /></ProtectedRoute>} />
      <Route path="/quizzes/new" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
      <Route path="/quizzes/:quizId" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
      <Route path="/scan" element={<ProtectedRoute><Scanner /></ProtectedRoute>} />
      <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
      <Route path="/tracking" element={<ProtectedRoute><ClassTracking /></ProtectedRoute>} />
      <Route path="/tracking/:classId" element={<ProtectedRoute><ClassDashboard /></ProtectedRoute>} />
      <Route path="/tracking/:classId/student/:studentId" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
      <Route path="/tags" element={<ProtectedRoute><TagsManager /></ProtectedRoute>} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/abonnement" element={<ProtectedRoute><Abonnement /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

import { ChatWidget } from "./components/ChatWidget";

function AuthAwareChatWidget() {
  const { user } = useAuth();
  if (!user) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <AuthAwareChatWidget />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
